<template>
  <v-card width="350">
    <v-col align="center">
      <h3 class="mt-5 mb-2" align="center">Паспорт водохранилища</h3>

      <v-row v-if="properties">
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">ID объекта</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ properties.id }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Название водоема</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="name"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Тип водоема</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
              :items="passport_pondtype"
              v-model="pond_type_id"
              item-text="name"
              item-value="id"
              placeholder="Тип водоема"
              outlined
              dense
              hide-details
              class="mb-1"
              clearable
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Назначение</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="purpose"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Водоисточник</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="water_source"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Широта</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ latitude }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Долгота</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ longitude }}</v-card-text>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Площадь зеркала (км2)</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="surface_area"
              type="number"
              step="0.001"
              min="0"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Периметр (км)</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="perimeter"
              type="number"
              step="0.001"
              min="0"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Средняя глубина (м)</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="average_depth"
              type="number"
              step="0.001"
              min="0"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Объем (млн. м3)</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="volume"
              type="number"
              step="0.001"
              min="0"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Введен в эксплуатацию</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-menu v-model="plantingDateMenu">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="exploitation_year"
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  clearable
              ></v-text-field>
            </template>
            <v-date-picker-years min="1960" max="2024" v-model="exploitation_year" scrollable></v-date-picker-years>
          </v-menu>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Принадлежность</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="belonging"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="16">
          <v-select
              :items="passport_serviceorganization"
              v-model="serviceorganizations"
              item-text="name"
              item-value="id"
              placeholder="Обслуживающая организация"
              outlined
              dense
              hide-details
              class="mb-1"
              clearable
              multiple
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Примечание</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="note"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Разделение по расположению</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
              class="text-end"
              v-model="separation_by_location"
              outlined
              dense
              hide-details
              clearable
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6">
          <v-card-text class="text-start">Адм. район</v-card-text>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-text class="text-end">{{ district_name }}</v-card-text>
        </v-col>
      </v-row>

      <div class="mt-2">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-card-text class="text-end">
              <v-btn type="button" class="font-weight-bold" @click="saveClick"
              >Сохранить</v-btn
              >
            </v-card-text>
          </v-col>
          <v-col v-if="isDraw" cols="12" sm="6" justify="end">
            <v-card-text class="text-start"
            ><v-btn type="button" class="font-weight-bold" @click="clearData"
            >Очистить</v-btn
            ></v-card-text
            >
          </v-col>
          <v-col v-else cols="12" sm="6" justify="end">
            <v-card-text class="text-start"
            ><v-btn
                type="button"
                class="font-weight-bold"
                @click="deleteClick"
            >Удалить</v-btn
            ></v-card-text
            >
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-card>
</template>

<script>
import Vue from "vue";
import { URL_API } from "@/settings/apiConnect";

export default {
  name: "ReservoirPassport",

  props: {
    saveWater: Function,
    deleteWater: Function,
    properties: Object,
    isDraw: Boolean
  },

  data() {
    return {
      plantingDateMenu: false,
      passport_pondtype: [],
      passport_serviceorganization: [],
      passport_belonging: [],

      name: null,
      pond_type_id: null,
      purpose: null,
      water_source: null,
      district_id: null,
      latitude: null,
      longitude: null,
      surface_area: null,
      perimeter: null,
      average_depth: null,
      volume: null,
      exploitation_year: null,
      belonging: null,
      note: null,
      separation_by_location: null,
      serviceorganizations: [],

      district_name: null,
    };
  },

  methods: {
    saveClick() {
      const data = {
        name: this.name,
        pond_type_id: this.pond_type_id,
        purpose: this.purpose,
        water_source: this.water_source,
        district_id: this.district_id,
        latitude: this.latitude,
        longitude: this.longitude,
        surface_area: this.surface_area,
        perimeter: this.perimeter,
        average_depth: this.average_depth,
        volume: this.volume,
        exploitation_year: this.exploitation_year,
        belonging: this.belonging,
        note: this.note,
        separation_by_location: this.separation_by_location
      };

      this.saveWater(data);
    },
    deleteClick() {
      this.deleteWater();
    },
    clearData() {
      this.name = null;
      this.pond_type_id = null;
      this.purpose = null;
      this.water_source = null;
      this.district_id = null;
      this.latitude = null;
      this.longitude = null;
      this.surface_area = null;
      this.perimeter = null;
      this.average_depth = null;
      this.volume = null;
      this.exploitation_year = null;
      this.belonging = null;
      this.note = null;
      this.separation_by_location = null;
      this.serviceorganizations = [];
    },

  },

  async mounted() {
    let response = await Vue.axios.get(`${URL_API}pondtype`);
    this.passport_pondtype = response.data;
    let response2 = await Vue.axios.get(`${URL_API}serviceorganization`);
    this.passport_serviceorganization = response2.data;

    if (this.properties?.id) {
      response = await Vue.axios.get(
          `${URL_API}reservoir/view/${this.properties.id}`
      );
      const data = response.data;
      console.log("данные воды", data);
      this.name = data.name;
      this.pond_type_id = data.pond_type_id;
      this.purpose = data.purpose;
      this.water_source = data.water_source;
      this.district_id = data.district_id;
      this.latitude = data.latitude;
      this.longitude = data.longitude;
      this.surface_area = data.surface_area;
      this.perimeter = data.perimeter;
      this.average_depth = data.average_depth;
      this.volume = data.volume;
      this.exploitation_year = data.exploitation_year;
      this.belonging = data.belonging;
      this.note = data.note;
      this.separation_by_location = data.separation_by_location;
      this.serviceorganizations = data.serviceorganizations;

      if (this.district_id) {
        this.district_name = data.district.name;
      }
    }
  }
};
</script>

<style scoped>
::v-deep .v-input__slot {
  margin: 0;
  max-height: 32px;
  min-height: 32px !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-btn:not(.v-btn--round).v-size--default {
  height: 32px;
  font-size: 12px;
}

::v-deep input,
p,
.v-input,
.v-card__text,
.v-text-field >>> label {
  font-size: 12px;
}

::v-deep .v-card__text {
  padding: 0;
}

::v-deep .v-select__selections {
  flex-wrap: nowrap;
}

::v-deep .v-text-field {
  padding-top: 0;
}
</style>
